import { EXTERNAL_SHARE } from '@confluence/named-routes';

export const isExternalShareRequest = () => !!EXTERNAL_SHARE.match(window.location.pathname);
